import React from "react";
import ImageLogoComponent from "../../../Image/ImageLogoComponent";
import TypographyComponent from "../../../Typography/ThypographyComponent";
import ButtonComponent from "../../../Button/ButtonComponent";

interface SidebarButtonProps {
    label: string;
    path: string;
    icon: any;
    onClickOption: (value: string) => void;
}

const SidebarButtonComponent = (props: SidebarButtonProps) => {
    const pathActive = window.location.pathname.includes(props.path);

    return <ButtonComponent
        id="nav-xpto"
        sx={{
            // width: 183,
            height: 52,
            opacity: 1,
            transform: 'rotate(0deg)',
            // py: '12px',
            px: '16px',
            background: pathActive ? "#FFE4D0" : "transparent",
            display: 'flex',
            alignItems: 'center',
            justifyContent: "flex-start",
            gap: 2,
            borderRadius: '8px',
            boxSizing: 'border-box'            
        }}
        onClick={() => props.onClickOption(props.path)}
    >
        <ImageLogoComponent
            sx={{
                width: 20,
                height: 20,
                borderRadius: 0
            }}
            src={props.icon}
            alt="logo"
        />

        <TypographyComponent
            variant="body2"
            sx={{
                fontFamily: '"Font 1", sans-serif',
                fontWeight: pathActive ? 600 : 400,
                fontSize: '13.1px',
                lineHeight: '20px',
                letterSpacing: '0em',
                color: pathActive ? "#FF8C42" : "#3D2817",
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                verticalAlign: 'middle',
                borderRadius: '6px',
                textTransform: 'none',
            }}
        >
            {props.label}
        </TypographyComponent>
    </ButtonComponent>
}

export default SidebarButtonComponent;